module.exports = __webpack_public_path__ + "app/principal/user/modal-add-user-authorization-1eDmHoJC.html";